import React, { useCallback, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { X } from "react-feather";

const NumericFilter = (props) => {
  const {
    column: { filterValue, setFilter },
  } = props;

  const filterPrefix = "$NUMBER=";
  const filterLess = "<";
  const filterMore = ">";

  const [lessMore, setLessMore] = useState(false);
  const [localValue, setLocalValue] = useState("");

  const parseFilterValue = useCallback(() => {
    if (
      filterValue &&
      typeof filterValue === "string" &&
      filterValue.startsWith(filterPrefix)
    ) {
      var valueStartPos = filterPrefix.length;
      if (
        filterValue.substring(
          filterPrefix.length,
          filterPrefix.length + filterLess.length
        ) === filterLess
      ) {
        setLessMore(false);
        valueStartPos += filterLess.length;
      } else if (
        filterValue.substring(
          filterPrefix.length,
          filterPrefix.length + filterMore.length
        ) === filterMore
      ) {
        setLessMore(true);
        valueStartPos += filterMore.length;
      }

      var value = filterValue.substring(valueStartPos);
      setLocalValue(value);
    }
  }, [filterValue]);

  useEffect(() => {
    parseFilterValue();
  }, [parseFilterValue]);

  // useEffect(() => {
  //   setLessMore(
  //     filterValue && filterValue.length > 3 ? filterValue[2] === ">" : false
  //   );
  //   setLocalValue(
  //     filterValue && filterValue.length > 3 ? filterValue.substring(3) : ""
  //   );
  // }, [filterValue]);

  useEffect(() => {
    if (!localValue) return;

    var v = localValue;
    if (v.length > 0) {
      setFilter(filterPrefix + (!lessMore ? filterLess : filterMore) + v);
    } else {
      setFilter("");
    }
  }, [localValue, lessMore]);

  // const handleValueChange = (e) =>{

  // };

  return (
    <div className="d-flex justify-content-between align-items-center">
      <span
        style={{ cursor: "pointer" }}
        onClick={() => {
          setLessMore(!lessMore);
        }}
      >
        {!lessMore ? "less than" : "more than"}
      </span>
      <Form.Group className="flex-grow-1">
        <Form.Control
          type="number"
          value={localValue}
          onChange={(e) => {
            setLocalValue(e.target.value);
          }}
        />
      </Form.Group>
      <Button
        variant=""
        className="p-0 m-0"
        onClick={() => {
          setFilter("");
        }}
      >
        <X />
      </Button>
    </div>
  );
};

export default NumericFilter;
